import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
// TODO fix
// eslint-disable-next-line boundaries/element-types
import { selectEmail, selectOrganizationId } from '@/entities/session';
import { useAppSelector } from '@/shared/model';

interface ContextState {
  email: string;
  organizationId: string;
}

const Context = createContext<ContextState | null>(null);

interface Props {
  children: ReactNode;
}

export function FeatureFlagsProvider({ children }: Props) {
  const email = useAppSelector(selectEmail) || '';
  const organizationId = useAppSelector(selectOrganizationId) || '';

  return (
    <Context.Provider value={{ email, organizationId }}>
      {children}
    </Context.Provider>
  );
}

export const useFeatureFlagsContext = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error(
      'useFeatureFlagsContext hook used outside <FeatureFlagsProvider />',
    );
  }

  return context;
};
